import axios from "axios"
import React, { useEffect, useState } from "react"
import { Loader } from "../../components/Loader"
import { InvoiceREST } from "./PempemInvoiceList"
import { generateInvoicePDF } from "./generateInvoicePDF"
import { useNavigate, useSearchParams } from "react-router-dom"

type InvoiceDetailProps = {
    onErrorLoading?: (orgId: string) => void
}

export function PempemInvoiceDetail({ onErrorLoading }: InvoiceDetailProps) {

    const navigate = useNavigate()
    const [param] = useSearchParams()
    const pdfUrlParam = param.get("pdfUrl")
    const orgId = param.get("orgId")

    const [pdfUrl, setPdfUrl] = useState()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        const url = pdfUrlParam ? decodeURIComponent(pdfUrlParam) : undefined
        axios.get(url, {
            withCredentials: false,
        }).then((data) => {
            console.log('pdf info', data)
            generateInvoicePDF(data.data as any, (pdf) => {
                pdf.getDataUrl(doc => {
                    setPdfUrl(doc)
                })
            })
        }).catch(e => {
            console.log(e)
            if (onErrorLoading) {
                onErrorLoading?.(orgId)
            } else {
                navigate(-1)
            }
        })
            .finally(() => {
                setIsLoading(false)
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div style={{ height: '100%', border: '1px solid black' }}>
        {pdfUrl ? (
            <iframe
                title="PDF renderer"
                src={pdfUrl}
                style={{ width: '100%', height: '100%' }}
                frameBorder="0"
            ></iframe>
        ) : <Loader isLoading={isLoading} />}
    </div>)
}